/**
+ * JSON Schema for feeds query object.
+ *
+ * http://json-schema.org/
+ */
export default {
  id: "FeedsParams",
  type: "object",
  properties: {
    parentalControl: {
      type: "string",
      enum: ["1", "7", "15", "18"]
    },
    userId: { type: "string" },
    from: { type: "string" },
    to: { type: "string" },
    sort: {
      type: "string",
      enum: ["alphabetical", "lastAdded"]
    },
    feedUrl: { type: "string" }
  },
  dependencies: {
    userId: ["parentalControl"],
    to: ["from"],
    from: ["to"]
  }
};
